import React from 'react';
import styled from 'styled-components';

const optionsCountDaysMenu = [
  {
    id: '2days',
    value: '2',
    label: '2 дня',
  },
  {
    id: '3days',
    value: '3',
    label: '3 дня',
  },
  {
    id: '7days',
    value: '7',
    label: '7 дней',
  },
  {
    id: '14days',
    value: '14',
    label: '14 дней',
  },
  {
    id: '16days',
    value: '16',
    label: '16 дней',
  },
  {
    id: '30days',
    value: '30',
    label: '30 дней',
  },
];

const CountDayOfMenuBlock = ({ selectedDaysCount, changeDaysCount }) => {
  return (
    <WrapCountDaysMenuBlock>
      <H4>
        Выберите количество дней:
        <AdditionalText>* при изменении количества дней меню будет сброшено</AdditionalText>
      </H4>
      <CountDayBlock>
        {optionsCountDaysMenu.map((optionDaysCount) => {
          return (
            <DayRadioBlock key={optionDaysCount.id}>
              <RadioButton
                type="radio"
                id={optionDaysCount.id}
                value={optionDaysCount.value}
                name="dayCountGenerate"
                checked={selectedDaysCount === +optionDaysCount.value}
                onChange={(e) => changeDaysCount(+e.target.value)}
              />
              <Label htmlFor={optionDaysCount.id}>{optionDaysCount.label}</Label>
            </DayRadioBlock>
          );
        })}
      </CountDayBlock>
    </WrapCountDaysMenuBlock>
  );
};

export default CountDayOfMenuBlock;

const WrapCountDaysMenuBlock = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  max-width: 400px;
`;

const TypeMenuBlock = styled.div`
  padding-top: 10px;
  margin: 0 auto;
  border: 1px solid #c1c1c1;
  background: #fff;
  border-radius: 5px;
  box-shadow: 3px 3px 2px #afafaf;
`;

const CountDayBlock = TypeMenuBlock.extend`
  margin: 0 auto;
  display: flex;
  justify-content: space-around;
  padding: 10px 5px;
`;

const RadioBlock = styled.div`
  width: 300px;
  margin: 5px auto;
`;

const DayRadioBlock = RadioBlock.extend`
  margin: 0 auto;
  width: 25%;
`;

const RadioButton = styled.input`
  cursor: pointer;
  margin: 0 5px 0 0;
`;

const Label = styled.label`
  cursor: pointer;
`;

const H4 = styled.h4`
  text-align: center;
  margin: 5px 0px;
  font-size: 20px;
`;

const AdditionalText = styled.p`
  font-size: 12px;
  font-weight: normal;
`;



// WEBPACK FOOTER //
// ./src/Components/Common/CountDayOfMenuBlock.jsx